<template>
  <v-btn
    class="button"
    :class="mode"
    :disabled="disabled"
    @click="click"
    x-large
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'v-button',
  props: {
    buttonType: {
      type: String,
      default: 'default',
      validator(value) {
        return [
          'default',
          'primary',
          'primary-white',
          'gradient',
          'white-light',
        ].includes(value);
      },
    },
    disabled: Boolean,
    danger: Boolean,
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    },
  },
  computed: {
    mode() {
      return `button_${this.buttonType} ${this.danger ? 'button_danger' : ''}`;
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/variables';

.button {
  font: {
    family: "Roboto";
    weight: 500;
    size: 14px;
  }
  text-transform: uppercase;
  border-radius: 999px;
  height: 45px;
  width: 100%;
  border: none;
  cursor: pointer;
  transition: 0.25s ease-in !important;

  &_primary {

    background: $primary-blue;
    color: $white;

    &:hover:enabled {
      background-color: $turquoise;
    }

    &.button_danger {
      background: $red;
    }

  }

  &_primary-white {
    background: $white;
    color: $primary-blue;

    &:hover {
      background: linear-gradient(1.38deg, rgba(65, 208, 228, 0.3) -125.36%, $white 74.11%),
                  linear-gradient(180deg, $white 0%, rgba(255, 255, 255, 0) 100%);
      box-shadow: 0px 4px 4px rgba(79, 79, 79, 0.1);
    }
  }

  &_gradient {
    color: $white;
    background: linear-gradient(87.57deg, $primary-blue .92%, #41cfe4 37.21%, $primary-blue 60%);
    box-shadow: 0px 4px 4px rgba(79, 79, 79, 0.1);
    background-size: 300% auto;
    transition: .5s;

    &:hover {
      &:not(:disabled) {
        background-position: 100% 0;
      }
    }
  }

  &_white-light {
    background: none;
    color: $white;
    border: 2px solid $white;

    &:hover {
      color: $primary-blue;
      background: linear-gradient(1.38deg, rgba(65, 208, 228, 0.3) -125.36%, $white 74.11%),
                  linear-gradient(180deg, $white 0%, rgba(255, 255, 255, 0) 100%);
      box-shadow: 0px 4px 4px rgba(79, 79, 79, 0.1);
      border: none;
    }

  }

  &_default {

    background: none;
    color: $primary-blue;
    border: 2px solid $primary-blue;

    &:hover:enabled {
      color: $turquoise;
      border-color: $turquoise;
    }

    &.button_danger {
      color: $red;
      border-color: $red;
    }
  }

  &:disabled {
    opacity: 0.3;
  }

}
</style>
